<script lang="ts">
  import { cn } from '$lib/utils/misc';

  export let primary = false;
  export let secondary = false;
</script>

<div
  role="presentation"
  on:click={(e) => {
    e.stopPropagation();
  }}
  class:primary
  class:secondary
  class={cn('relative h-screen max-h-screen w-full sm:h-fit', $$props.class)}
>
  <div class="square left-0 top-0" />
  <div class="square right-0 top-0" />
  <div class="square bottom-0 left-0" />
  <div class="square bottom-0 right-0" />
  <div class="vertical-line left-0" />
  <div class="vertical-line right-0" />
  <div class="horizontal-line top-0" />
  <div class="horizontal-line bottom-0" />
  <slot />
</div>

<style lang="postcss">
  .square {
    @apply h-2xs w-2xs bg-gray-dark-11 absolute;
  }
  .vertical-line {
    @apply bg-gray-dark-2 absolute inset-y-3 w-0.5;
  }
  .horizontal-line {
    @apply bg-gray-dark-2 absolute inset-x-3 h-0.5;
  }
  .primary > .square {
    @apply bg-mint-dark-9;
  }
  .primary > .horizontal-line,
  .primary > .vertical-line {
    @apply bg-mint-dark-4;
  }

  .secondary > .square {
    @apply bg-orange-dark-10;
  }
  .secondary > .horizontal-line,
  .secondary > .vertical-line {
    @apply bg-orange-dark-2;
  }
</style>
